import { render, staticRenderFns } from "./Windows10.vue?vue&type=template&id=6a39156b&scoped=true&"
import script from "./Windows10.vue?vue&type=script&lang=js&"
export * from "./Windows10.vue?vue&type=script&lang=js&"
import style0 from "./Windows10.vue?vue&type=style&index=0&id=6a39156b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39156b",
  null
  
)

export default component.exports